import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput, NeuSelect } from "../../components/neu/Neu";
import { createBonus } from "../../api/bonuses";
import { SourcePicker } from "./SourcePicker";

const EMPTY = { user_id: "", amount: "", reason: "", payment_source_type: "cashbox", payment_source_id: "" };

// استمارة إصدار مكافأة: زر الإرسال معطّل حتى تُستكمل كل الحقول الإلزامية (ومنها مصدر الصرف).
export const BonusForm = ({ employees, boxes, onSaved, onClose }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });
  const employee = employees.find((e) => e.id === form.user_id);
  const ready = form.user_id && Number(form.amount) > 0 && form.reason.trim().length >= 10 && form.payment_source_id;

  const submit = async () => {
    setBusy(true);
    try {
      await createBonus({ ...form, amount: Number(form.amount) });
      toast.success(t("bonus.saved"));
      onSaved();
      onClose();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(detail?.message || (typeof detail === "string" ? detail : t("bonus.saveFailed")));
    }
    setBusy(false);
  };

  return (
    <NeuCard className="grid gap-3" data-testid="bonus-form">
      <h3 className="text-base font-black">{t("bonus.issue")}</h3>
      <div className="grid gap-3 sm:grid-cols-2">
        <label className="grid gap-1 text-xs font-bold">
          {t("bonus.fields.employee")} <span className="text-destructive">*</span>
          <NeuSelect data-testid="bonus-employee-select" value={form.user_id} onChange={set("user_id")}>
            <option value="">{t("bonus.pickEmployee")}</option>
            {employees.map((e) => (
              <option key={e.id} value={e.id}>{e.name}</option>
            ))}
          </NeuSelect>
        </label>
        <label className="grid gap-1 text-xs font-bold">
          {t("bonus.fields.amount")} <span className="text-destructive">*</span>
          <NeuInput data-testid="bonus-amount-input" type="number" min="1" value={form.amount}
                    onChange={set("amount")} dir="ltr" />
        </label>
        <label className="grid gap-1 text-xs font-bold sm:col-span-2">
          {t("bonus.fields.reason")} <span className="text-destructive">*</span>
          <NeuInput data-testid="bonus-reason-input" value={form.reason} onChange={set("reason")}
                    placeholder={t("bonus.fields.reasonHint")} />
        </label>
        <SourcePicker boxes={boxes} branchId={employee?.branch_ids?.[0]} type={form.payment_source_type}
                      id={form.payment_source_id} onChange={(patch) => setForm({ ...form, ...patch })} />
      </div>
      <p className="text-[11px] text-muted-foreground">{t("bonus.fields.sourceRequiredHint")}</p>
      <div className="flex flex-wrap gap-3">
        <NeuButton variant="primary" data-testid="bonus-create-submit-btn" disabled={!ready || busy}
                   onClick={submit}>{t("bonus.submit")}</NeuButton>
        <NeuButton data-testid="bonus-form-close" onClick={onClose}>{t("common.cancel")}</NeuButton>
      </div>
    </NeuCard>
  );
};
